<template>
  <div am-edit-modal>
    <div class="_background:black" am-edit-modal-bg @click="close()" />
    <i-card am-edit-modal-body>
      <template #header>
        <div class="_display:flex _align-items:center">
          <p class="_margin:1/4 _flex:1">
            {{ id }}
            <i-badge
              v-if="status === 'UPDATING'"
              color="danger"
              class="_margin:1/4"
              size="sm"
            >
              updating
            </i-badge>
          </p>
          <svg @click="copyUrl()" am-icon="color" viewBox="0 0 24 24" title="Copy record URL">
            <use xlink:href="@/assets/icons.svg#copy-link" x="0" y="0" width="24" height="24"></use>
          </svg>
          <i-icon am-icon-close name="ink-times" @click="close()" />
        </div>
      </template>
      <div am-edit class="_display:flex _height:100%">
        <div am-edit-element class="_padding-top:1 _padding-bottom:2 _padding-right:1">
          <div v-for="field in val" :key="field">
            <i-card
              v-if="field.category !== 'static'"
              class="_margin-bottom:1/2"
              :am-updating-element="status === 'UPDATING' ? '' : null"
            >
              <p>{{ field.name }}</p>
              <component v-if="field.category !== 'image'" :is="componentName(field.category)" :data="field" />
              <component v-if="field.category === 'image'" :is="componentName(field.category)"
                :data="field" :image="image" @delImg="deleteImage" @addImg="image.push($event)" />
            </i-card>
          </div>
        </div>
        <i-card am-activity class="_padding-top:1 _padding-bottom:2">
          <db-activity :val="val" />
        </i-card>
      </div>
    </i-card>
  </div>
</template>

<script>
import AttrItem from './modalItems/AttrItem'
import CheckboxItem from './modalItems/CheckboxItem'
import FieldItem from './modalItems/FieldItem'
import FieldsArrayItem from './modalItems/FieldsArrayItem'
import ImageItem from './modalItems/ImageItem'
import ParamsItem from './modalItems/ParamsItem'
import SelectItem from './modalItems/SelectItem'
import AllowedparamsItem from './modalItems/AllowedparamsItem'
import ParamssArrayItem from './modalItems/ParamssArrayItem'
import dbActivity from './activity/dbActivity'

import api from '@/_mixins/api'
import { mapMutations } from 'vuex'

export default {
  name: 'editModal',
  components: {
    AttrItem,
    CheckboxItem,
    FieldItem,
    FieldsArrayItem,
    ImageItem,
    ParamsItem,
    SelectItem,
    AllowedparamsItem,
    ParamssArrayItem,
    dbActivity
  },
  mixins: [api],
  data: () => ({
    image: [],
    imagesContent: {},
    aa: []
  }),
  computed: {
    status () {
      return this.val[0].status
    },
    val () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts
        .filter(el => el.rowIndex === this.$store.state.parts.openModalRow)
    },
    id () {
      return this.val.find(el => el.name === 'id').data
    }
  },

  methods: {
    ...mapMutations('ui', ['closeModal']),
    ...mapMutations('notifications', ['addNotification']),
    componentName: c => `${c[0].toUpperCase()}${c.substring(1)}Item`,
    close () {
      this.$store.state.parts.openModalRow = null
      const q = { ...this.$route.query }
      delete q.part_id
      this.$router.replace({ query: q })
    },
    deleteImage (event) {
      const index = this.image.findIndex(el => el.id === event)
      this.image.splice(index, 1)
    },
    async getImg () {
      const response = await this.request('GET', `${this.api.endpoint.loadImg}?part_id=${this.id}&noImages=1`)
      if (response.info.ok) {
        let imageResponse = response.body.part_images
        if (this.$store.state.parts.changedImages[this.$route.params.subtable]) {
          imageResponse.forEach(el => {
            const changedImage = this.$store.state.parts.changedImages[this.$route.params.subtable][el.id]
            if (changedImage) {
              if (changedImage.data.image) el.image = changedImage.data.image
              if (changedImage.data.alg) el.alg = changedImage.data.alg
              if (changedImage.data.params) el.params = changedImage.data.params
              if (changedImage.attrs) el.attrs = changedImage.attrs
            }
          })
          for (const key in this.$store.state.parts.changedImages[this.$route.params.subtable]) {
            if (key.includes('new') && key.includes(this.id)) {
              imageResponse.push({
                image: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.image,
                alg: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.alg || null,
                params: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.params || {},
                attrs: this.$store.state.parts.changedImages[this.$route.params.subtable][key].attrs || [],
                id: key,
                side: this.$store.state.parts.changedImages[this.$route.params.subtable][key].side,
                mime: 'svg',
                type: this.$store.state.parts.changedImages[this.$route.params.subtable][key].type,
                isNew: true
              })
            }
          }
        }
        if (imageResponse && this.$store.state.parts.changedParts[this.$route.params.subtable]?.[this.id]?.data.delete_image_ids) {
          imageResponse = imageResponse.filter(el => {
            const deletedImages = this.$store.state.parts.changedParts[this.$route.params.subtable][this.id].data.delete_image_ids
            if (!deletedImages.includes(el.id)) return el
            else return false
          })
        }
        this.image = imageResponse
      }
    },
    async getImgContent () {
      const response = await this.request('GET', `${this.api.endpoint.loadImg}?part_id=${this.id}&onlyImages=1`)
      if (response.info.ok) {
        const images = response.body.part_images
        images.forEach(img => {
          this.imagesContent[img.id] = img.image
        })
      }
    },
    fillImgContent () {
      this.image.forEach((el, index) => {
        if (el.image) return
        el.image = this.imagesContent[el.id]
        if (!el.image) {
          console.error('can not fill image with content, id: ' + el.id)
          return
        }
        if (!el.image.includes('xmlns="http://www.w3.org/2000/svg"')) {
          el.image = el.image.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"')
        }
        this.image[index].imageBase64 = btoa(unescape(encodeURIComponent(el.image)))
      })
    },
    copyUrl () {
      navigator.clipboard.writeText(document.location.href)
      this.addNotification({
        notification: {
          type: 'success',
          message: 'Record URL copied'
        }
      })
    }
  },
  mounted () {
    if (!this.id.toString().includes('copy') && !this.id.toString().includes('new')) {
      Promise.all([
        this.getImg(),
        this.getImgContent(),
        this.$store.dispatch('activity/getActivity', `part_id=${this.id}`)
      ]).then(() => this.fillImgContent())
    } else if (
      (this.id.toString().includes('copy') || this.id.toString().includes('new')) &&
      this.$store.state.parts.changedImages[this.$route.params.subtable]
    ) {
      for (const key in this.$store.state.parts.changedImages[this.$route.params.subtable]) {
        this.image.push({
          ...this.$store.state.parts.changedImages[this.$route.params.subtable][key],
          image: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.image,
          alg: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.alg || null,
          params: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.params || {},
          attrs: this.$store.state.parts.changedImages[this.$route.params.subtable][key].attrs || [],
          id: key,
          isNew: true
        })
      }
    }
    this.closeModal(this.close)
    window.editModal = this
    if (this.id) {
      const currentQuery = { ...this.$route.query }
      currentQuery.part_id = this.id
      this.$router.replace({ query: currentQuery })
    }
  },
  unmounted () {
    this.$store.state.activity.data = null
    this.closeModal(null)
  }
}
</script>

<style lang="scss">
[am-edit-modal] {
  top: 0;
  z-index: 1000;
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  [am-edit-modal-bg] {
    opacity: 0.4;
    height: 100%;
    width: 100%;
  }

  [am-edit-modal-body]>.card-body {
    overflow-y: hidden;
    padding-top: 0;
    padding-bottom: 0;
  }

  [am-edit-modal-body]>.card-header {
    >div {
      >p {
        flex: 1;
      }

      >svg {
        margin: 10px;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }

  [am-edit-modal-body] {
    position: absolute;
    height: 90%;
    max-width: 70%;
    width: 70%;
    overflow-x: hidden;
  }

  [am-icon-close] {
    cursor: pointer;
    width: 0.5rem;
  }

  [am-edit] {
    [am-edit-element] {
      overflow-y: scroll;
      width: 70%;
    }
    [am-activity] {
      width: 30%;
      overflow-y: scroll;
    }
    [am-icon] {
      cursor: pointer;
      width: 1.375rem;
      height: 1.375rem;
    }
  }
  .-light [am-icon~='color'] {
    ----color-stroke:  var(--contrast-color-for-light-background);
  }
  .-dark [am-icon~='color'] {
    ----color-stroke: var(--contrast-color-for-dark-background);
  }
  .checkbox {
    .checkbox-label {
      &::before {
        min-width: var(----size);
        border-color: var(----border-color--checked);
      }
    }
  }
}
</style>
